import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../configApi";
const initialState = {
  isLoading: false,
  listFileSpam: [],
  listReport: [],
  isOpenModalGetLog: false,
  listTypeSpam: [],
  dataLogSpam: [],
  dataLogReport: [],
  isRefetch: false,
};
const SpamSlice = createSlice({
  name: "spam",
  initialState,
  reducers: {
    setOpenModalGetLogSpam: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //lấy data danh sách file spam
      .addCase(getListFileSpam.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListFileSpam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listFileSpam = action.payload;
      })
      .addCase(getListFileSpam.rejected, (state) => {
        state.isLoading = true;
      })

      // lấy log spam
      .addCase(getLogFileSpam.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogFileSpam.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.dataLogSpam = action.payload;
        state.isOpenModalGetLog = true;
      })
      .addCase(getLogFileSpam.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      //lấy data danh sách type của file spam
      .addCase(getListTypeSpam.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListTypeSpam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listTypeSpam = action.payload;
      })
      .addCase(getListTypeSpam.rejected, (state) => {
        state.isLoading = true;
      })
      //lấy data danh sách report
      .addCase(getListReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listReport = action.payload;
      })
      .addCase(getListReport.rejected, (state) => {
        state.isLoading = true;
      })
      // lấy log report
      .addCase(getLogReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogReport.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.dataLogReport = action.payload;
        state.isOpenModalGetLog = true;
      })
      .addCase(getLogReport.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      });
  },
});
export default SpamSlice;
export const { setOpenModalGetLogSpam } = SpamSlice.actions;
export const getListFileSpam = createAsyncThunk(
  "spam/getListFileSpam",
  async (body) => {
    let config = [];
    if (body.timeStart === "" && body.timeEnd === "") {
      config = {
        keySearch: "",
        option: {
          limit: 10,
          offset: 2,
          order: "asc",
        },
      };
    } else {
      config = body;
    }
    try {
      const res = await instance.post(`/spam/getListFileSpam`, config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getListTypeSpam = createAsyncThunk(
  "spam/getListTypeSpam",
  async () => {
    try {
      const res = await instance.get(`/spam/getTypeFileDataSpam`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getLogFileSpam = createAsyncThunk(
  "spam/getLogFileSpam",
  async (id) => {
    try {
      const res = await instance.get(`/spam/getLogFileSpam?fileGuid=${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const deleteFileSpam = createAsyncThunk(
  "spam/getLogFileSpam",
  async (id) => {
    try {
      const res = await instance.delete(`/spam/deleteFileSpam?guid=${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const updateFileSpam = createAsyncThunk(
  "spam/updateFileSpam",
  async (body) => {
    try {
      const res = await instance.put(`/spam/updateFileSpam`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const addFileSpam = createAsyncThunk(
  "spam/addFileSpam",
  async (body) => {
    try {
      const res = await instance.post(`/spam/uploadFileSpam`, body);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
//get list report
export const getListReport = createAsyncThunk(
  "spam/getListReport",
  async (config) => {
    try {
      const res = await instance.post(`/spam/getListReport`, config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getLogReport = createAsyncThunk(
  "spam/getLogReport",
  async (id) => {
    try {
      const res = await instance.get(`/spam/getLogReportScam?fileGuid=${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
